import React from 'react';
import { Box, Typography, LinearProgress } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import useStyles from './styles.js';

export default function WaitingUi() {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Box className={classes.waitingWrapper}>
      <Typography align="center" variant="subtitle1" aria-live="assertive" aria-role="alert">
        {t('just_a_moment', 'Just a Moment')}
      </Typography>
      <LinearProgress className={classes.linearProgress} variant="indeterminate" />
    </Box>
  );
}
